import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entityName: string; // Name of the entity being deleted
  confirmationText: string; // Text that user must type to enable the confirm button
  title: string; // Dialog title
  description: string; // Dialog description
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  entityName,
  confirmationText,
  title,
  description,
}) => {
  const [inputText, setInputText] = useState("");

  const isConfirmDisabled = inputText !== confirmationText;

  useEffect(() => {
    if (!open) {
      setInputText(""); // Reset input text when dialog is closed
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={true}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ marginBottom: 2 }}
        >
          {description} - {entityName}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label={`Type "${confirmationText}" to confirm`}
          fullWidth
          variant="outlined"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          autoFocus
          disabled={isConfirmDisabled}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
